import { useEffect, useState } from 'react';

import { logger } from '../utils/logger';

/**
 * A custom React hook that persists state in localStorage.
 */
export function usePersistedState<T>(
  localStorageKey: string,
  defaultValue: T
): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [value, setValue] = useState<T>(() => {
    try {
      const item = localStorage.getItem(localStorageKey);
      return item !== null ? JSON.parse(item) : defaultValue;
    } catch (error) {
      logger.error(`Error parsing localStorage key "${localStorageKey}":`, { error });
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(localStorageKey, JSON.stringify(value));
    } catch (error) {
      logger.error(`Error setting localStorage key "${localStorageKey}":`, { error });
    }
  }, [value, localStorageKey]);

  return [value, setValue];
}
